import { storage } from './storage';

type TLanguageTag = 'en' | 'ru' | 'fr';

const AVAILABLE_LANGUAGES: TLanguageTag[] = ['en', 'ru', 'fr'];
const DEFAULT_LANGUAGE: TLanguageTag = 'en';

const SAVED_LANGUAGE_TAG_KEY_NAME = 'userLocale';

class UserLanguage {
  getBrowserLanguage(): TLanguageTag | undefined {
    const browserLanguage = navigator.language || navigator.languages[0];

    if (browserLanguage) {
      const [browserLanguageTag] = browserLanguage.split('-') as [TLanguageTag, ...any];

      if (AVAILABLE_LANGUAGES.includes(browserLanguageTag)) {
        return browserLanguageTag;
      }
    }

    return undefined;
  }

  getLanguage(): TLanguageTag {
    const savedLanguage = storage.getItem(SAVED_LANGUAGE_TAG_KEY_NAME) as TLanguageTag;

    if (savedLanguage && AVAILABLE_LANGUAGES.includes(savedLanguage)) {
      return savedLanguage;
    }

    const browserLanguage = this.getBrowserLanguage();

    if (browserLanguage && AVAILABLE_LANGUAGES.includes(browserLanguage)) {
      return browserLanguage;
    }

    return DEFAULT_LANGUAGE;
  }

  setLanguage(language: TLanguageTag): TLanguageTag {
    if (!AVAILABLE_LANGUAGES.includes(language)) {
      return this.getLanguage();
    }

    storage.setItem(SAVED_LANGUAGE_TAG_KEY_NAME, language);

    return language;
  }
}

const userLanguage = new UserLanguage();

export type { TLanguageTag };
export { userLanguage, AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE };
